<template>
  <!-- <pre>
    {{ myCarousel.data }}
    </pre
  > -->
  <div class="relative" style="border-radius: 16px; overflow: hidden">
    <!-- Slider ma mensi chybu, umoznuje slidovat i v pripade 1 obrazku, zobrazi se znovu ten samy a porad dokola, vypada to blbe <RJ, 02.05.2023 16:37:11> -->
    <template v-if="photos.length <= 1">
      <aw-img
        :image="photos[0]"
        src="https://dummyimage.com/1230x870.jpg"
        size="1230x870x8"
        style="border-radius: 16px"
      />
    </template>
    <template v-else>
      <Carousel ref="myCarousel" :wrap-around="true">
        <Slide v-for="photo in photos" :key="photo.id">
          <aw-img
            :image="photo"
            src="https://dummyimage.com/1230x870.jpg"
            size="1230x870x8"
            style="border-radius: 16px"
          />
        </Slide>

        <template #addons> </template>
      </Carousel>

      <div
        v-if="myCarousel?.data.slidesCount > 1"
        class="lg:absolute mt-4 lg:mt-0 left-5 bottom-5 space-x-3"
      >
        <span
          @click="prev"
          class="bg-white w-9 h-9 rounded-full inline-flex justify-center items-center cursor-pointer select-none border border-border-common"
        >
          <aw-icon icon="arrow-left" class="w-5 h-5" />
        </span>
        <span
          @click="next"
          class="bg-white w-9 h-9 rounded-full inline-flex justify-center items-center cursor-pointer select-none border border-border-common"
        >
          <aw-icon icon="arrow-right" class="w-5 h-5" />
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import { Carousel /*, Navigation, Pagination,*/, Slide } from 'vue3-carousel'

import 'vue3-carousel/dist/carousel.css'

export default defineComponent({
  name: 'Ambi slider',
  props: ['photos'],
  components: {
    Carousel,
    Slide
    // Pagination,
    // Navigation
  },
  setup() {
    const myCarousel = ref()

    function prev() {
      myCarousel.value.prev()
    }

    function next() {
      myCarousel.value.next()
    }

    return { myCarousel, prev, next }
  },

  mounted() {
    // console.log(this.photos)
  }
})
</script>

<style>
.carousel {
  /* Make the width 100% plus the width of the gap between slides */
  width: calc(100% + 1.25rem);

  /* replace 0.625rem with half of the gap between slides */
  transform: translateX(-0.625rem);
}

.carousel__slide {
  /* Once again, replace 0.625rem with half of the width you want the gap to be */
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
</style>
